export const parseCalendarValueAsString = (date: string[]) => {
  return date.map(d => {
    const [month, day, year] = d.split("/");
    return `${year}-${month}-${day}`;
  });
};
